<flx-resources-grid
  [tableDef]="documentsTableColumns"
  [inputGridOptions]="gridOptions()"
  (gridReady)="onGridReady($event)"
  emptyMsg="No documents found."
/>
